import { useState, useMemo } from "react"
import CrimeMap from "./CrimeMap"

function MapView() {
  const tomorrow = useMemo(() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d.toISOString().split('T')[0]
  }, [])

  const minDate = useMemo(() => {
    const d = new Date()
    d.setDate(d.getDate() - 7)
    return d.toISOString().split('T')[0]
  }, [])

  const [selectedDate, setSelectedDate] = useState(tomorrow)
  const [crimeType, setCrimeType] = useState('violent-crime')

  return (
    <div className="flex h-full w-full flex-col md:relative">
      <div className="z-[1000] flex flex-shrink-0 flex-col gap-3 border-b border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-800 sm:flex-row sm:flex-wrap sm:items-center md:absolute md:right-4 md:top-4 md:rounded-lg md:border-0 md:shadow-lg">
        <div className="flex min-w-0 flex-1 items-center gap-2 sm:flex-initial">
          <label htmlFor="crime-type" className="shrink-0 text-sm font-medium text-gray-700 dark:text-gray-200">
            Type
          </label>
          <select
            id="crime-type"
            value={crimeType}
            onChange={(e) => setCrimeType(e.target.value)}
            className="min-w-0 flex-1 text-sm border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:flex-initial sm:min-w-[10rem]"
          >
            <option value="violent-crime">Violent Crime</option>
            <option value="property-crime">Property Crime</option>
            <option value="other-crime">Other Crime</option>
          </select>
        </div>
        <div className="flex min-w-0 flex-1 items-center gap-2 sm:flex-initial">
          <label htmlFor="date-picker" className="shrink-0 text-sm font-medium text-gray-700 dark:text-gray-200">
            Date
          </label>
          <input
            id="date-picker"
            type="date"
            value={selectedDate}
            min={minDate}
            max={tomorrow}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="min-w-0 flex-1 text-sm border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 [color-scheme:light] dark:[color-scheme:dark] sm:flex-initial"
          />
        </div>
      </div>
      <div className="relative min-h-0 flex-1 w-full">
        <CrimeMap selectedDate={selectedDate} crimeType={crimeType} />
      </div>
    </div>
  )
}

export default MapView
